module.exports = __webpack_public_path__ + "static/media/7-focus.81c6a107.svg";